import { UniverseEnum } from '../../../business/api/dashboard/universeEnum';
import { ContractsViewModel } from '../../../business/model/crossroads/contracts.view-model';
import { CrossroadsViewModel } from '../../../business/model/crossroads/crossroads.view-model';
import { TypeContractEnum } from '../../../business/model/crossroads/typeContractEnum';

export class CrossroadsUtils {
    /**
     * Sort and order contracts in viewModel according to contrats are Sosh contracts or Orange contracts
     * @param {CrossroadsViewModel} viewModel
     * @param {boolean} isSosh
     * @return {CrossroadsViewModel}
     */
    public static orderModel(viewModel: CrossroadsViewModel, isSosh: boolean): void {
        for (const contract of viewModel.contracts) {
            const isSoshContract: boolean = contract.brand.toUpperCase() === UniverseEnum.SOSH;
            contract.order = this.getRankHundreds(contract, isSosh, isSoshContract) + contract.order;
        }
        viewModel.contracts.sort((a: ContractsViewModel, b: ContractsViewModel) => {
            return a.order - b.order;
        });
    }

    /**
     * get hundrends to assign strong or low rank to sort contracts according to whether they are orange or sosh
     * @param {ContractsViewModel} contract
     * @param {boolean} isSosh
     * @param {boolean} isSoshContract
     * @return {number}
     */
    private static getRankHundreds(contract: ContractsViewModel, isSosh: boolean, isSoshContract: boolean): number {
        let hundred = 0;
        if (contract.typeContract === TypeContractEnum.MULTI) {
            hundred = 900;
        } else if (isSosh) {
            switch (contract.typeContract) {
                case TypeContractEnum.ACTIVE:
                    if (!isSoshContract) {
                        hundred = 300;
                    }
                    break;
                case TypeContractEnum.TERMINATED:
                    hundred = isSoshContract ? 100 : 400;
                    break;
                case TypeContractEnum.PROTECTEDHOUSE:
                    hundred = isSoshContract ? 200 : 500;
                    break;
                default:
                    break;
            }
        } else {
            switch (contract.typeContract) {
                case TypeContractEnum.ACTIVE:
                    if (isSoshContract) {
                        hundred = 300;
                    }
                    break;
                case TypeContractEnum.TERMINATED:
                    hundred = !isSoshContract ? 100 : 400;
                    break;
                case TypeContractEnum.PROTECTEDHOUSE:
                    hundred = !isSoshContract ? 200 : 500;
                    break;
                default:
                    break;
            }
        }
        return hundred;
    }

    /**
     * get Sosh or Orange icon
     * @return {string}
     */
    public static getIconBrand(
        universe: UniverseEnum,
        viewModel: ContractsViewModel,
        typeContractViewModel: any,
    ): UniverseEnum {
        let iconBrand: UniverseEnum = null;
        if (universe === UniverseEnum.MIXED && typeContractViewModel.picto) {
            if (
                viewModel.brand.toUpperCase() === UniverseEnum.SOSH &&
                typeContractViewModel.picto.toUpperCase() === UniverseEnum.SOSH
            ) {
                iconBrand = UniverseEnum.SOSH;
            } else if (
                viewModel.brand.toUpperCase() === UniverseEnum.ORANGE &&
                typeContractViewModel.picto.toUpperCase() === UniverseEnum.ORANGE
            ) {
                iconBrand = UniverseEnum.ORANGE;
            }
        }
        return iconBrand;
    }
}
